import { useEffect, useState } from "react";

import "./Calendar.css"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AnualEvents, _single, _WorkActivity } from "../../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { Modal } from "../../../../../theme/Component/Modal";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { InputColor } from "../../../../../theme/Input/InputColor";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";

interface form {
    Month: number;
    Year: number;
    Week: number;
    Day: number;
}

export const Calendar = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AnualEvents);
    const { instance: instanceActivity, bean: beanActivity, setBean: setBeanActivity, lista: listaActivity, setLista: setListaActivity } = useDataBean(_WorkActivity);

    const [festiveDays, setFestiveDays] = useState<any[]>([]);
    const [formData, setFormData] = useState<form>({
        Month: _single.getCurrentMonth(),
        Year: _single.getCurrenYear(),
        Week: 1,
        Day: new Date().getDate(),
    })

    const modalAdd = useModal(`Agregar Evento`, MODAL_LG);

    useEffect(() => {
        if (typeof (formData.Month) == "number" && formData.Year) {
            getLista();
            getFestiveDays();
        }
    }, [formData])

    const pad = (num: number) => num.toString().padStart(2, "0");

    const getLista = () => {
        const props = {
            EventDateYear: formData.Year,
            EventDateMonth: formData.Month,
            State: 1,
        }
        instance.getAnualEventsCatalogPorPropiedades(props, null).then(
            (resp) => {
                if (resp.length > 0) {
                    resp.forEach(element => {
                        const d = element.DataBeanProperties;

                        d.HoraInicio = d.TimeStartHour != null ? `${pad(d.TimeStartHour ?? 0)}:${pad(d.TimeStartMinutes ?? 0)}` : "N/P";
                        d.HoraFin = d.TimeFinHour != null ? `${pad(d.TimeFinHour ?? 0)}:${pad(d.TimeFinMin ?? 0)}` : "N/P";
                    });
                    setLista(resp)
                } else {
                    setLista([])
                }
            }
        ).catch(
            error => toast.error(error)
        );
    }

    // const getListaActivity =()=>{
    //     instanceActivity.getWorkActivityRender()
    // }

    const getFestiveDays = () => {
        instance.getFestiveDayRender(formData.Year, formData.Month).then(
            (resp) => {
                setFestiveDays(Array.isArray(resp) ? resp : []);
            }
        ).catch(
            error => toast.error(error)
        );
    }

    const addOpenAddModal = (day?: number) => {
        const now = new Date();
        setBean({
            EventDateYear: formData.Year,
            EventDateMonth: formData.Month,
            State: 1,
            IDEmployee: _single.getAccountID(),
            IsVisible: false,
            Repeat: false,
            EventDateDay: day ?? formData.Day ?? now.getDate(),
            TimeStartHour: now.getHours(),
            TimeStartMinutes: 0,
            TimeFinHour: now.getHours() + 1,
            TimeFinMin: 0,
            ColorCode: "#0ea5e9",
        })
        modalAdd.open();
    }

    const openEventModal = (event: any) => {
        setBean(event.DataBeanProperties);
        modalAdd.open();
    }

    const addEvent = () => {
        instance.updateAnualEvents(bean).then(
            () => {
                modalAdd.close();
                getLista();
            }
        ).catch(err => toast.error(err))
    }

    const navigateMonth = (direction: number) => {
        const date = new Date(formData.Year, formData.Month + direction, 1);
        setFormData({
            ...formData,
            Year: date.getFullYear(),
            Month: date.getMonth(),
            Day: 1,
        });
    }

    const goToToday = () => {
        setFormData({
            ...formData,
            Month: _single.getCurrentMonth(),
            Year: _single.getCurrenYear(),
            Day: new Date().getDate(),
        });
    }

    const formatEventDate = (event: any) => {
        const dato = event.DataBeanProperties;
        return new Date(dato.EventDateYear, dato.EventDateMonth, dato.EventDateDay).toLocaleDateString("es-CO", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    }

    const getFestiveDayNumber = (festiveDay: any) => {
        const dayValue = festiveDay.Day ?? festiveDay.DataBeanProperties?.Day;
        if (!dayValue) return null;

        return Number(String(dayValue).substring(8, 10));
    }

    const getFestiveDayDescription = (festiveDay: any) => {
        return festiveDay.Description ?? festiveDay.DataBeanProperties?.Description ?? "Día festivo";
    }

    const getFestiveDaysForDay = (day: number) => {
        return festiveDays.filter((festiveDay) => getFestiveDayNumber(festiveDay) === day);
    }

    const daysInMonth = new Date(
        bean.EventDateYear ?? formData.Year,
        (bean.EventDateMonth ?? formData.Month) + 1,
        0
    ).getDate();

    const calendarEvents = lista ?? [];
    const upcomingEvents = [...calendarEvents].sort((a, b) => {
        const dateA = new Date(
            a.DataBeanProperties.EventDateYear,
            a.DataBeanProperties.EventDateMonth,
            a.DataBeanProperties.EventDateDay,
            a.DataBeanProperties.TimeStartHour ?? 0,
            a.DataBeanProperties.TimeStartMinutes ?? 0
        ).getTime();
        const dateB = new Date(
            b.DataBeanProperties.EventDateYear,
            b.DataBeanProperties.EventDateMonth,
            b.DataBeanProperties.EventDateDay,
            b.DataBeanProperties.TimeStartHour ?? 0,
            b.DataBeanProperties.TimeStartMinutes ?? 0
        ).getTime();
        return dateA - dateB;
    });

    return (
        <>
            <div className="row calendar-dashed">
                <div className="col-xl-3">
                    <div className="card calendar-welcome-card">
                        <div className="card-body">
                            <div className="d-flex">
                                <div className="flex-shrink-0">
                                    <i className="ri-calendar-event-line calendar-welcome-icon"></i>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h6 className="fs-15 mb-1">Calendario personal</h6>
                                    <p className="text-muted mb-0">Consulta tus próximos eventos y crea recordatorios desde el día que necesites.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card calendar-action-card">
                        <div className="card-body">
                            <BasicButton eventClick={() => { addOpenAddModal() }} icon="mdi mdi-plus" children={`Crear evento`} />
                        </div>
                    </div>

                    <div className="calendar-sidebar-section">
                        <div className="calendar-sidebar-title">
                            <h5 className="mb-1">Próximos eventos</h5>
                            <span>{upcomingEvents.length}</span>
                        </div>
                        <p className="text-muted">Eventos activos de este mes</p>
                        <div className="calendar-event-list mb-3 overflow-auto">
                            {upcomingEvents.length > 0 ? (
                                upcomingEvents.map((events, idx) => {
                                    const dato = events.DataBeanProperties;
                                    return (
                                        <button
                                            type="button"
                                            className="calendar-event-card"
                                            key={idx}
                                            style={{ borderLeftColor: dato.ColorCode || "#0d6efd" }}
                                            onClick={() => openEventModal(events)}
                                        >
                                            <span className="calendar-event-card-title">{dato.EventTitle || "Evento sin nombre"}</span>
                                            <span className="calendar-event-card-meta">
                                                <i className="ri-time-line"></i>
                                                {formatEventDate(events)} · {dato.HoraInicio} - {dato.HoraFin}
                                            </span>
                                            {dato.Since && (
                                                <span className="calendar-event-card-footer">
                                                    {dato.Since}
                                                </span>
                                            )}
                                        </button>
                                    );
                                })
                            ) : (
                                <div className="calendar-empty-state">
                                    <i className="ri-calendar-check-line"></i>
                                    <p className="mb-0">Sin eventos disponibles</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-xl-9">
                    <div className="card calendar-main-card card-h-100">
                        <div className="card-body">
                            <div className="calendar-toolbar">
                                <div>
                                    <span className="calendar-view-label">Vista mensual</span>
                                    <h4 className="calendar-current-month">
                                        {new Date(formData.Year, formData.Month).toLocaleString("es-CO", {
                                            month: "long",
                                            year: "numeric",
                                        })}
                                    </h4>
                                </div>
                                <div className="calendar-toolbar-actions">
                                    <button type="button" className="calendar-nav-button" onClick={() => navigateMonth(-1)} aria-label="Mes anterior">
                                        <i className="ri-arrow-left-s-line"></i>
                                    </button>
                                    <button type="button" className="btn btn-light btn-sm" onClick={goToToday}>
                                        Hoy
                                    </button>
                                    <button type="button" className="calendar-nav-button" onClick={() => navigateMonth(1)} aria-label="Mes siguiente">
                                        <i className="ri-arrow-right-s-line"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="calendar-table-wrap">
                                <table className="table calendar-table">
                                    <thead>
                                        <tr>
                                            {[
                                                { label: "Lun", title: "Lunes" },
                                                { label: "Mar", title: "Martes" },
                                                { label: "Mié", title: "Miércoles" },
                                                { label: "Jue", title: "Jueves" },
                                                { label: "Vie", title: "Viernes" },
                                                { label: "Sáb", title: "Sábado" },
                                                { label: "Dom", title: "Domingo" },
                                            ].map((day) => (
                                                <th key={day.label} title={day.title}>{day.label}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(() => {
                                            const year = formData.Year;
                                            const month = formData.Month;

                                            const today = new Date();
                                            const isToday = (day: number) =>
                                                today.getDate() === day &&
                                                today.getMonth() === month &&
                                                today.getFullYear() === year;

                                            const firstDay = new Date(year, month, 1);
                                            const lastDay = new Date(year, month + 1, 0);
                                            const totalDays = lastDay.getDate();
                                            const startDay = (firstDay.getDay() + 6) % 7;

                                            const getEventsForDay = (day: number) => (
                                                calendarEvents.filter((e) => e.DataBeanProperties.EventDateDay === day)
                                            )

                                            const cells = [];

                                            for (let i = 0; i < startDay; i++) {
                                                cells.push(<td key={`empty-${i}`} className="calendar-empty-cell"></td>);
                                            }

                                            for (let day = 1; day <= totalDays; day++) {
                                                const dayEvents = getEventsForDay(day);
                                                const dayFestiveDays = getFestiveDaysForDay(day);
                                                const visibleEvents = dayEvents.slice(0, 3);
                                                const hiddenEventsCount = dayEvents.length - visibleEvents.length;
                                                const todayClass = isToday(day) ? "is-today" : "";
                                                const festiveClass = dayFestiveDays.length > 0 ? "is-festive" : "";

                                                cells.push(
                                                    <td key={day} className={`calendar-day-cell ${todayClass} ${festiveClass}`}>
                                                        <div className="calendar-day-header">
                                                            {isToday(day) ? (
                                                                <span className="calendar-today-number">
                                                                    {day}
                                                                </span>
                                                            ) : (
                                                                <span className="calendar-day-number">{day}</span>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="calendar-add-day"
                                                                title="Crear evento en este día"
                                                                onClick={() => addOpenAddModal(day)}
                                                            >
                                                                <i className="ri-add-line"></i>
                                                            </button>
                                                        </div>

                                                        {dayFestiveDays.map((festiveDay, idx) => (
                                                            <div
                                                                className="calendar-festive-pill"
                                                                key={`${day}-festive-${idx}`}
                                                                title={getFestiveDayDescription(festiveDay)}
                                                            >
                                                                <i className="ri-calendar-check-line"></i>
                                                                <strong>{getFestiveDayDescription(festiveDay)}</strong>
                                                            </div>
                                                        ))}

                                                        {visibleEvents.map((event, idx) => {
                                                            const evento = event.DataBeanProperties;
                                                            return (
                                                                <button
                                                                    type="button"
                                                                    key={idx}
                                                                    className="calendar-event-pill"
                                                                    title={`${evento.EventTitle || "Evento sin nombre"} · ${evento.HoraInicio} - ${evento.HoraFin}`}
                                                                    style={{ borderLeftColor: evento.ColorCode || "#0d6efd" }}
                                                                    onClick={() => openEventModal(event)}
                                                                >
                                                                    <span>{evento.HoraInicio}</span>
                                                                    <strong>{evento.EventTitle || "Evento sin nombre"}</strong>
                                                                </button>
                                                            )
                                                        })}
                                                        {hiddenEventsCount > 0 && (
                                                            <span className="calendar-more-events">
                                                                +{hiddenEventsCount} más
                                                            </span>
                                                        )}
                                                    </td>
                                                );
                                            }

                                            const rows = [];
                                            for (let i = 0; i < cells.length; i += 7) {
                                                rows.push(<tr key={`row-${i}`}>{cells.slice(i, i + 7)}</tr>);
                                            }
                                            return rows;
                                        })()}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={() => { addEvent() }}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Nombre del evento</label>
                        <input type="text" className="form-control" value={bean.EventTitle ?? ""} onChange={(e) => { setBean({ ...bean, EventTitle: e.target.value }) }} />
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-4">
                                <YearSelector tittle="AA" onChange={(e) => { setBean({ ...bean, EventDateYear: e }) }} value={bean.EventDateYear} />
                            </div>
                            <div className="col-md-4">
                                <MonthConstantsEditor label="MM" idSelect={bean.EventDateMonth} name="" onChange={(e) => { setBean({ ...bean, EventDateMonth: e }) }} />
                            </div>
                            <div className="col-md-4">
                                <label>DD</label>
                                <select
                                    className="form-select"
                                    value={bean.EventDateDay ?? ""}
                                    onChange={(e) => {
                                        const value = e.target.value ? Number(e.target.value) : null
                                        setBean({ ...bean, EventDateDay: value })
                                    }}
                                >
                                    <option value="">...</option>
                                    {Array.from({ length: daysInMonth }, (_, i) => (
                                        <option key={i} value={i + 1}>
                                            {(i + 1).toString().padStart(2, "0")}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <label>Hora de inicio</label>
                        <div className="row">
                            <div className="col-md-6">
                                <select
                                    className="form-control"
                                    value={bean.TimeStartHour ?? ""}
                                    onChange={(e) => {
                                        const value = e.target.value ? Number(e.target.value) : null
                                        setBean({ ...bean, TimeStartHour: value })
                                    }}
                                >
                                    <option value="">...</option>
                                    {[...Array(24)].map((_, i) => (
                                        <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <select
                                    className="form-control"
                                    value={bean.TimeStartMinutes ?? ""}
                                    onChange={(e) => {
                                        const value = e.target.value ? Number(e.target.value) : null;
                                        setBean({ ...bean, TimeStartMinutes: value })
                                    }}
                                >
                                    <option value="">...</option>
                                    {[...Array(12)].map((_, i) => (
                                        <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <label>Hora de fin</label>
                        <div className="row">
                            <div className="col-md-6">
                                <select
                                    className="form-control"
                                    value={bean.TimeFinHour ?? ""}
                                    onChange={(e) => {
                                        const value = e.target.value ? Number(e.target.value) : null
                                        setBean({ ...bean, TimeFinHour: value })
                                    }}
                                >
                                    <option value="">...</option>
                                    {[...Array(24)].map((_, i) => (
                                        <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <select
                                    className="form-control"
                                    value={bean.TimeFinMin ?? ""}
                                    onChange={(e) => {
                                        const value = e.target.value ? Number(e.target.value) : null;
                                        setBean({ ...bean, TimeFinMin: value })
                                    }}
                                >
                                    <option value="">...</option>
                                    {[...Array(12)].map((_, i) => (
                                        <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <InputColor onChange={(e) => { setBean({ ...bean, ColorCode: e }) }} value={bean.ColorCode} label="Color de la etiqueta" />
                    </div>

                    <div className="col-md-6">
                        <BasicSwitch label="¿Se repite?" estado={bean.Repeat} eventChange={(e) => { setBean({ ...bean, Repeat: e }) }} />
                    </div>

                    {bean.Repeat &&
                        <div className="col-md-6">
                            <label>Tipo de repetición</label>
                            <select className="form-control" value={bean.RepeatType ?? ""} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, RepeatType: value })
                            }}>
                                <option value="">...</option>
                                <option value="1">Diario</option>
                                <option value="2">Mensual</option>
                                <option value="3">Anual</option>
                            </select>
                        </div>
                    }

                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea className="form-control" value={bean.Description ?? ""} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} ></textarea>
                    </div>
                </div>
            </Modal>
        </>
    )
}
